import { render, staticRenderFns } from "./GroupChart.vue?vue&type=template&id=7898ab25"
import script from "./GroupChart.vue?vue&type=script&lang=js"
export * from "./GroupChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports